import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export const CallToAction = () => {
  return <div className="my-8 text-center" data-id="element-103">
      <a href="https://shop.tryhealora.com/products/nad-cellular-energy-formula" data-id="element-104">
        <button className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-md shadow-lg text-lg uppercase tracking-wider transform transition hover:scale-105 flex items-center mx-auto justify-center" data-id="element-105">
          Claim Your 45% Discount Today
          <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-106" />
        </button>
      </a>
      <p className="mt-3 text-sm text-green-700 font-medium" data-id="element-107">
        Start Your Energy Transformation Now
      </p>
    </div>;
};